import React from 'react'
import { SimpleGrid, Skeleton } from '@chakra-ui/react'
import { BRAND_LIMIT } from '@constants/brand.constant'

const SkeletonBrands = () => {
  const displaySkelotons = () => {
    const arr = Array.from({ length: BRAND_LIMIT }, (v, k) => k)
    return arr.map((v) => {
      return (
        <Skeleton
          key={v}
          startColor={'bgSkeleton'}
          endColor={'bgSkeleton'}
          h={'160px'}
          flex={1}
        />
      )
    })
  }
  return (
    <SimpleGrid
      templateColumns={{
        sm: '1fr 1fr',
        md: '6fr 6fr',
        lg: '3fr 3fr 3fr',
        xl: '4fr 4fr 4fr 4fr'
      }}
      spacing={5}
    >
      {displaySkelotons()}
    </SimpleGrid>
  )
}

export default SkeletonBrands
